import { getServerStatusApi } from 'api/system'
import errorHandler from 'utils/errorHandler'

export default () => async (dispatch) => {
  try {
    return await getServerStatusApi()
  } catch (error) {
    return errorHandler(error)
  }
}
